import {
  Component,
  OnInit,
  ElementRef
} from '@angular/core';

import { ITimeLine } from '../../shared';

import * as d3 from 'd3';

@Component({
  selector: '[awair-line-list]',
  templateUrl: './line-list.component.html',
  styleUrls: ['./line-list.component.scss']
})

export class LineListComponent implements OnInit {

  private isInitialized: boolean = false;

  constructor(private el: ElementRef) { }

  ngOnInit() {
  }

  update(timelineList: ITimeLine[], lineGenerator: any, lineColorList: string[]): void {
    if (this.isInitialized) {
      d3.select(this.el.nativeElement)
        .selectAll('path')
        .remove();
    }

    if (lineGenerator && timelineList) {
      for (let i = 0; i < timelineList.length; i++) {
        if (timelineList[i] != null) {
          d3.select(this.el.nativeElement)
            .append('path')
            .attr('class', 'line')
            .classed('line-' + i, true)
            .style('stroke-width', '1.5px')
            .style('stroke', lineColorList[i % 8])
            .style('stroke-linecap', 'round')
            .style('stroke-dasharray', () => {
              if ((i % 8) > 3) { return '8,3,1,3'; }
            })
            .attr('d', lineGenerator(timelineList[i]));
        }
      }
      this.isInitialized = true;
    }
  }
}
